module.exports = __webpack_public_path__ + "static/media/OMS.e85d9b58.png";